// @flow
import styled from 'styled-components';
import DefaultTheme from '.';
import { se300 } from '../../colors';
/*::
  import type { TabsThemeType } from '.';
*/

var thm
/*: TabsThemeType */
= Object.assign({}, DefaultTheme, {
  List: styled(DefaultTheme.List).withConfig({
    displayName: "shipa-ecommerce__List",
    componentId: "sc-18enp1i-0"
  })(["border:1px solid ", ";"], se300())
});
export default thm;